export default function TimeTrackingIcon2({ className = '' }) {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.2083 6.286C12.1366 4.87742 10.5493 3.95223 8.79554 3.71397C7.04175 3.47571 5.26515 3.94389 3.85657 5.01553C2.44798 6.08716 1.52279 7.67447 1.28453 9.42825C1.04627 11.182 1.51446 12.9586 2.58609 14.3672C3.65773 15.7758 5.24503 16.701 6.99881 16.9393C7.8672 17.0572 8.75032 17.003 9.59775 16.7797C10.4452 16.5564 11.2403 16.1683 11.9378 15.6377C12.6352 15.1071 13.2214 14.4443 13.6627 13.6871C14.104 12.93 14.3918 12.0934 14.5098 11.225C14.6278 10.3566 14.5736 9.47347 14.3502 8.62604C14.1269 7.77861 13.7389 6.98346 13.2083 6.286ZM13.2083 6.286L14.7762 4.71802M5.64768 1H10.1449M7.89631 7.23994V10.3275"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
